/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const createCollectionSubtitleBodySchema = z.object({
  srtRaw: z.string().min(1),
  filename: z.string().min(1),
});

export type ICreateCollectionSubtitleBody = z.infer<typeof createCollectionSubtitleBodySchema>;
